<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListMarcas";

export default {
  data() {
    return {
      subjectPermission: "Marcas"
    };
  },
  methods: {},
  components: {
    List
  }
};
</script>
